import { Route, Routes } from 'react-router-dom';
import { ArticleComments } from '@pages/articles/ArticleComments/index.tsx';
import { ArticlePage } from '@pages/articles/articlePage/index.tsx';
import { ArticlePublicationPage } from '@pages/articles/articlePublicationPage/index.tsx';
import { RecommendedArticlePage } from '@pages/articles/ReccomendedArticlePage/index.tsx';
import { RecommendedArticleComments } from '@pages/articles/RecommendedArticleComments/index.tsx';
import { ArticleEdit } from '@widgets/articles/article-edit/index.tsx';
import { RecommendModal } from '@widgets/articles/RecommendModal/index.tsx';
import { CommentEdit } from '@widgets/shared/Comments/CommentEdit/index.tsx';
import { ArticlesList } from './articles-list';

export const Articles = () => {
  return (
    <>
      <Routes>
        <Route path=":code">
          <Route index element={<ArticlesList />} />
          <Route path=":articleId">
            <Route index element={<ArticlePage />} />
            <Route path="edit">
              <Route index element={<ArticleEdit />} />
            </Route>
            <Route path="publication" element={<ArticlePublicationPage />} />

            {/* комментарии */}
            <Route path="comments">
              <Route index element={<ArticleComments />} />
              <Route path=":commentId" element={<CommentEdit />} />
            </Route>
          </Route>
          <Route path="recommended/:hash">
            <Route index element={<RecommendedArticlePage />} />
            <Route path="comments">
              <Route index element={<RecommendedArticleComments />} />
              <Route path=":commentId" element={<CommentEdit />} />
            </Route>
          </Route>
        </Route>
      </Routes>
      <RecommendModal />
    </>
  );
};
